import {GlobalContext, PatientContextService} from '@/services/patient-context-service';

const gabiEnv = __GABI_ENV__;

const subdomain = PatientContextService.getGlobalContext() === GlobalContext.HINSCOPE ? 'analytics' : 'pediarity';

/**
 * Interface extracted from node_modules/@react-native-firebase/app/lib/index.d.ts
 */
export interface FirebaseAppOptions {
    /**
     * The Google App ID that is used to uniquely identify an instance of an app.
     */
    appId: string;

    /**
     * An API key used for authenticating requests from your app, e.g.
     * "AIzaSyDdVgKwhZl0sTTTLZ7iTmt1r3N2cJLnaDk", used to identify your app to Google servers.
     */
    apiKey: string;

    /**
     * The database root URL, e.g. "http://abc-xyz-123.firebaseio.com".
     */
    databaseURL?: string;

    /**
     * The Project ID from the Firebase console, for example "abc-xyz-123".
     */
    projectId: string;

    /**
     * The tracking ID for Google Analytics, e.g. "UA-12345678-1", used to configure Google Analytics.
     */
    gaTrackingId?: string;

    /**
     * The Google Cloud Storage bucket name, e.g. "abc-xyz-123.storage.firebase.com".
     */
    storageBucket?: string;

    /**
     * The Project Number from the Google Developer's console, for example "012345678901", used to
     * configure Google Cloud Messaging.
     */
    messagingSenderId?: string;

    /**
     * iOS only - The OAuth2 client ID for iOS application used to authenticate Google users, for example
     * "12345.apps.googleusercontent.com", used for signing in with Google.
     */
    clientId?: string;

    /**
     * iOS only - The Android client ID used in Google AppInvite when an iOS app has its Android version, for
     * example "12345.apps.googleusercontent.com".
     */
    androidClientId?: string;

    /**
     * iOS only - The URL scheme used to set up Durable Deep Link service.
     */
    deepLinkURLScheme?: string;

    [name: string]: unknown;
}

export const firebaseConfigProd: FirebaseAppOptions = {
    apiKey: 'AIzaSyC1js_nlYfQKMJhwCqqvf_amz_QXQpA44Q',
    projectId: 'hinlab-cloud-prod',
    messagingSenderId: '797430993027',
    appId: '1:797430993027:web:a7e01949c69cd01bb24bb6',
};
export const firebaseConfigAcceptance: FirebaseAppOptions = {
    apiKey: 'AIzaSyB6MKYpyhhsCpzwMNkoG7kCdpdTWMCII4o',
    projectId: 'hinlab-cloud-acc',
    messagingSenderId: '142621266157',
    appId: '1:142621266157:web:64aca84f0c022872a0fce4',
};
export const firebaseConfigPilot: FirebaseAppOptions = {
    apiKey: 'AIzaSyDeU1Dkdy8v0h4kkNCMySumQPyd1UJk8Tc',
    projectId: 'hinlab-cloud-pilot',
    messagingSenderId: '262927445296',
    appId: '1:262927445296:web:8167294d51e0d65a6f2cf5',
};
export const firebaseConfigDevelopment: FirebaseAppOptions = {
    apiKey: 'AIzaSyDTPVW5doU73at8Mkjc5C7870p40etBZ4A',
    projectId: 'hinlab-cloud-dev',
    messagingSenderId: '492142476535',
    appId: '1:492142476535:web:b0d3b519f55d9c9a10e7f2',
};

const config = {
    appId: 'myapp',
    appName: 'Gabi Analytics',

    backendApi: {
        baseUrlNoDomain: 'unknown',
        //baseUrl: `${domain}/${clientDomain}`,
        baseUrl: 'unknown',
        baseUrlTemplates: 'unknown/templates',
        timeout: 1000,
    },

    auth0: gabiEnv === 'production' ? {
        domain: 'account.gabismartcare.com',
        returnTo: `https://${subdomain}.hinlab.com`,
        clientId: 'KBAFoIXJk0ghlKHFG9lDR2L0wKOmrDgB',
        audience: 'gsc-pediarity-prod.eu.auth0.com',
        cacheLocation: 'memory',
    } : gabiEnv === 'acceptance' ? {
        domain: 'acceptance.account.gabismartcare.com',
        returnTo: `https://acceptance.${subdomain}.hinlab.com`,
        clientId: '3fAM7t4cVUhvLTKBmmlPFmCuLM1Njua4',
        audience: 'gsc-pediarity-acc.eu.auth0.com',
        cacheLocation: 'memory',
    } : gabiEnv === 'pilot' ? {
        domain: 'hinlab-analytics-pilot.us.auth0.com',
        returnTo: `https://pilot.${subdomain}.hinlab.com`,
        clientId: 'Zy76LP0tKNAGGCHpN4LKirpUyc7Y22b8',
        audience: 'hinlab-analytics-pilot.us.auth0.com',
        cacheLocation: 'localstorage',
    } : {
        domain: 'gabi-analytics-dev-w8sfj0vv.eu.auth0.com',
        returnTo: `https://dev.${subdomain}.hinlab.com`,
        clientId: 'pVIDtnlaLf6GTMmkWh52QBNlAxpvGgpG',
        audience: 'gabi-analytics-dev-w8sfj0vv.eu.auth0.com',
        cacheLocation: 'localstorage',
    },

    auth0Test: {
        username: 'elza.weykmans+cypress@gabismartcare.com',
        password: 'e2e-testing-42',
        domain: 'gabi-analytics-dev-w8sfj0vv.eu.auth0.com',
        returnTo: `https://dev.${subdomain}.hinlab.com`,
        clientId: 'pVIDtnlaLf6GTMmkWh52QBNlAxpvGgpG',
        audience: 'gabi-analytics-dev-w8sfj0vv.eu.auth0.com',
    },

    /* eslint-disable indent */
    firebase: (
        gabiEnv === 'production' ? firebaseConfigProd :
        gabiEnv === 'acceptance' ? firebaseConfigAcceptance :
        gabiEnv === 'pilot' ? firebaseConfigPilot :
        /*gabiEnv === 'development' ?*/ firebaseConfigDevelopment
    ),
    /* eslint-enable indent */

    cloudFunction: (
        gabiEnv === 'production' ? {
            hcpConnectionNotification: 'https://us-central1-hinlab-cloud-prod.cloudfunctions.net/hcp-connection-notification',
        } : gabiEnv === 'pilot' ? {
            hcpConnectionNotification: 'https://us-central1-hinlab-cloud-pilot.cloudfunctions.net/hcp-connection-notification',
        } : gabiEnv === 'acceptance' ? {
            hcpConnectionNotification: 'https://us-central1-hinlab-cloud-acc.cloudfunctions.net/hcp-connection-notification',
        } : /*gabiEnv === 'development' ?*/ {
            hcpConnectionNotification: 'https://us-central1-hinlab-cloud-dev.cloudfunctions.net/hcp-connection-notification',
        }
    ),

    feedbackAlerts: {
        lifetime: 10, // Time for a feedback message to be displayed (in seconds)
    },

    dateFormats: {
        time: 'HH:mm',
        fullTime: 'HH:mm:ss',
        date: 'dd/MM/yyyy',
        dateTime: 'dd/MM/yyyy HH:mm',
        dateTimeDay: 'eeee dd/MM/yyyy HH:mm',
        dateTimeSeconds: 'dd/MM/yyyy HH:mm:ss',
    },
};

export {config};
